import type { PostProcessorModule } from 'i18next'
import { nbsp } from './nbsp'

/** Czy kod języka wskazuje polski ('pl', 'pl-PL', …). */
function isPolish(lng: unknown): boolean {
  return typeof lng === 'string' && /^pl(-|$)/i.test(lng)
}

/**
 * PostProcessor i18next o nazwie "nbsp" (PLAN-IMPLEMENTACJI §8.4).
 *
 * Aplikuje `nbsp()` (twarde spacje U+00A0) wyłącznie dla języka polskiego —
 * język odczytywany jest z opcji wywołania `t()` (`options.lng`), a gdy go tam
 * nie ma, z aktywnego języka translatora. Rejestrowany przez `createI18n`
 * (`use(...)` + `postProcess: ['nbsp']`).
 */
export const nbspPostProcessor: PostProcessorModule = {
  type: 'postProcessor',
  name: 'nbsp',
  process(value, _key, options, translator) {
    const translatorLanguage: unknown = (translator as { language?: unknown } | null | undefined)?.language
    const lng = options.lng ?? (typeof translatorLanguage === 'string' ? translatorLanguage : undefined)
    return isPolish(lng) ? nbsp(value) : value
  },
}
